var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PlateTitle',{attrs:{"title":"投保历史记录"}}),_c('List',{staticClass:"list"}),_c('a-pagination',{staticClass:"pagination",attrs:{"default-current":6,"total":500}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }